import { render } from "./index.vue?vue&type=template&id=3360a4e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3360a4e0&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3360a4e0"]])

export default __exports__